"use client";
import React, { useState, useRef } from 'react';
export const Context = React.createContext();

const initialState = {
  activePanel: "VideosC",
  captrueImage:[],
  modalData: {
    isOpen: false,
    type: null,
    folderUpdate: false,
    galeryUpdate: false,
    galleryStatus: null,
    status: null,
    openFrom: null,
  },
  currentFolderData: null,
  currentTemplateId: 0,
  currentFontFamilyVideoTitle: null,
  currentFontFamilyVideoSubTitle: null,
  currentFolderName: null,
  currentFolderId: 0,
  currentDBFolderId: null,
  currentGalleryName: null,
  currentGalleryVideoTitle: null,
  currentGalleryVideoSubTitle: null,
      currentTitleColor:null,
  currentSubTitleColor: null,
    
  currentFontFamilyLogoTxt: null,
  currentLogoColor: null,
  currentLogoFontSize:null,
  currentGalleryId: null,
  currentDBGalleryId: null,
  currentVideoId: 0,
  currentDBVideoId: null,
  currentVideoThumbnail:null,
  videoArr: null,
  photoArr:null,
  selectedVideos: [],
  currentGalleryData: {},
  adminDetails: {},
  backgroundMedia: {
    videoUrl: null,
    musicUrl: null,
    imgUrl: null,
  },
  allFolderData: [],
  temp: "ram",
};

const AppContext = (props) => {
  const [state, setState] = useState(initialState);

  // ✅ Single file progress
  const [showProgress, setShowProgress] = useState(false);
  const [fileName, setFileName] = useState(null);
  const [percentage, setPercentage] = useState(0);

  const startProgress = (file = null) => {
    setShowProgress(true);
    setFileName(file || null);
    setPercentage(0);
  };

  const updateProgress = (percent) => setPercentage(percent);

  const stopProgress = (uniqueId) => {
    console.log("STOP PROGRESS ",uniqueId);
     setProgressFiles((prev) => prev.filter(file => file.uniqueId !== uniqueId));
    setShowProgress(false);
    setFileName(null);
    setPercentage(0);
  };

  // ✅ Multi-file progress
  const [progressFiles, setProgressFiles] = useState([]); // [{ uniqueId, fileName, percentage }]
  const cancelledIdsRef = useRef(new Set());

  const showProgressBar = (fileName, percent, uniqueId, txt) => {
    if (cancelledIdsRef.current.has(uniqueId)) return;

    setProgressFiles((prev) => {
      const existingIndex = prev.findIndex(f => f.uniqueId === uniqueId);
      const updated = [...prev];

      if (existingIndex !== -1) {
        updated[existingIndex] = { uniqueId, fileName, percentage: percent, txt:txt };
      } else {
        updated.push({ uniqueId, fileName, percentage: percent, txt:txt });
      }

      return updated;
    });
  };

  const stopProgressBarById = (uniqueId) => {
    setProgressFiles((prev) => prev.filter(file => file.uniqueId !== uniqueId));
    cancelledIdsRef.current.add(uniqueId);
    console.log("CANCELID ", uniqueId);
  };

  
  const resetProgressBars = () => {
    setProgressFiles([]);
    cancelledIdsRef.current = new Set();
  };

  return (
    <Context.Provider
      value={{
        value: [state, setState],
        progress: {
          // ✅ Single file progress
          showProgress,
          startProgress,
          stopProgress,
          fileName,
          percentage,
          updateProgress,

          // ✅ Multi-file progress
          files: progressFiles,
          showProgressBar,
          stopProgressBarById,
          resetProgressBars,
          cancelledIdsRef: cancelledIdsRef.current,
        },
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default AppContext;
